module.exports = __webpack_public_path__ + "img/Million.6b3bf097.svg";